module.exports = __webpack_public_path__ + "media/application/images/family-a008b259928c634f0e4533c0db0f0b63.png";